import { GovCard, GovGridItem, GovSkeleton } from '@gov-design-system-ce/react';
import { LayoutGap } from '@gov-nx/ui/web';

export const UsefulLinksSkeleton = () => (
	<>
		{Array.from({ length: 8 }).map((_, index) => (
			<GovGridItem
				column="12"
				columnMd="4"
				// eslint-disable-next-line react/no-array-index-key
				key={index}>
				<GovCard>
					<LayoutGap gap="s">
						<GovSkeleton
							shape="circle"
							width="48"
							height="48"
							className="h-12!"
						/>
						<GovSkeleton
							size="l"
							width="70%"
						/>
						<div>
							<GovSkeleton size="xs" />
							<GovSkeleton
								size="xs"
								width="90%"
							/>
							<GovSkeleton
								size="xs"
								width="50%"
							/>
						</div>
						<GovSkeleton size="xl" />
					</LayoutGap>
				</GovCard>
			</GovGridItem>
		))}
	</>
);
